import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { LittleModalCreateEdit } from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { twinFetchPostJSON } from '../../../../../../../../../../utils/globals/data'
import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { UserInnerModelType } from '@teinor/erp/types/company/userInner'

interface ModalAddWorkingCenterUserProps extends ModalEditComponentProps {}

const ModalAddWorkingCenterUser: React.FC<ModalAddWorkingCenterUserProps> = ({...rest}) => {
    const {t} = useTwinTranslation()
    const params = useParams<{ id: string }>()
    const id = params.id
    const { users } = useModalAddWorkingCenterUserLogic()
    const fields: FormRender<UserInnerModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'id',
                    label: t('user', 'Usuario'),
                    component: 'CustomSelectWithSearchBar',
                    items: users || {},
                    required: true
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: id
                }
            ]
        }
    ]
    return (<LittleModalCreateEdit fields={fields} url={'/api/app/workingCenter/workingCenterUser/updateUserInner'} translations={{
        title: t('addUserToWorkingCenter', 'Añadir usuario al Centro de trabajo'),
        button: t('add', 'Añadir')
    }} haveButtonPermissions={true} {...rest} />)
}

const useModalAddWorkingCenterUserLogic = () => {
    const [users, setUsers] = useState<TwinDictionary | null>(null)

    const getUsers = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/workingCenter/workingCenterUser/getAllUsersInners', { where: { 'WorkingCenterId': null}})
        if(result){
            setUsers(dictionaryComplexFromJsonArr(result ||[], ))
        }
    }, [])

    useEffect(() => {
        getUsers()
    }, [getUsers])

    return {users}
}

export default ModalAddWorkingCenterUser